import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../authorization.service';

export const AuthorizationGuard: CanActivateFn = (
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean  => {

    const authService = inject(AuthorizationService);
    if (authService.hasValidLoginToken) {
        return true;
    }

    inject(Router).navigate(['/account/login']);
    return false;
};